var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgPencil = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "#fff",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.37 1.342h.004a.284.284 0 0 1 .2.082h.001l3.001 3.001a.286.286 0 0 1 .024.027l-.014.01.025.245v.014l-.005.047.006.046v.006a.406.406 0 0 1-.039.05L12.57 6.832l-.004.004-7.698 7.741a.284.284 0 0 1-.216.082H1.625a.284.284 0 0 1-.283-.284V11.37c0-.038.007-.075.02-.11L.97 11.1l.394.16a.283.283 0 0 1 .06-.091l7.742-7.741 2.003-2.004a.284.284 0 0 1 .201-.082Zm-7.032 12.75h.176l.124-.125 7.034-7.033.3-.3-.3-.301-2.004-2.005-.3-.3-.301.3-7.034 7.034-.125.124v2.606H4.338Zm7.732-8.157.301.302.301-.303.999-1.006.298-.3-.3-.3-1.997-1.997-.3-.3-.3.299-1.006.998-.302.3.301.302 2.005 2.005Z",
  stroke: "currentColor",
  strokeWidth: 0.85
})));

export default SvgPencil;